import { Component } from '@verndale/core';
import Pristine from 'pristinejs';
import serialize from 'form-serialize';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $form: this.el,
      $error: this.el._$('.form-error'),
      $submit: this.el._$('[type="submit"]'),
      $episerverErrors: this.el._$$('.Form__Element__ValidationError')
    };

    this.dom.$loadingRing = document.createElement('div');
    this.dom.$loadingRing.classList.add('loading-ring');
    this.dom.$loadingRing.setAttribute('role', 'presentation');
    this.dom.$loadingRing.innerHTML = '<div></div><div></div><div></div><div></div>';

    this.successClass = 'form--success';
    this.dom.$episerverErrors ? this.errorClass = 'Form__Element__ValidationError' : this.errorClass = 'form-input__error';
    this.loadingClass = 'form--loading';
    this.defaultError = this.dom.$error?.textContent;
    this.defaultSubmitDisableValue = this.dom.$submit ? this.dom.$submit.disabled : false;

    this.validate();
  }

  addListeners() {
    this.dom.$form._on('submit', this.handleSubmit.bind(this));
    this.dom.$form._on('reset', this.handleReset.bind(this));
    this.dom.$form._on('input', this.handleSubmitButtonEnability.bind(this));
    this.dom.$form._on('animationstart', this.handleAnimationStart.bind(this));
    this.dom.$form._on('input', this.handleInput.bind(this));
    this.dom.$form._on('onautocomplete', this.handleAutocomplete.bind(this));
  }

  validate() {
    this.pristineForm = new Pristine(this.dom.$form, {
      classTo: 'form-input',
      errorClass: 'form-input--error',
      successClass: 'form-input--success',
      errorTextParent: 'form-input',
      errorTextTag: 'small',
      errorTextClass: 'form-input__error'
    });
  }

  setLoading(bool) {
    this.dom.$form.classList.toggle(this.loadingClass, bool);

    if (!this.dom.$submit) this.dom.$submit = this.el._$('[type="submit"]');
    bool ? this.dom.$submit.appendChild(this.dom.$loadingRing) : this.dom.$loadingRing.remove();
  }

  handleSubmit(e) {
    e.preventDefault();

    const isValid = this.pristineForm.validate();
    if (!isValid || (!this.el.getAttribute('action') && !this.el.parentNode.classList.contains('episerver-form'))) return;

    this.setLoading(true);

    const headers = {
      'content-type': 'application/json'
    };

    const token = this.el._$('[name=__RequestVerificationToken]')?.value;
    if (token) headers.__RequestVerificationToken = token;

    window
      .fetch(this.dom.$form.action, {
        method: 'POST',
        body: JSON.stringify(
          serialize(this.dom.$form, { hash: true, disabled: true, empty: true })
        ),
        headers
      })
      .then(r => r.json())
      .then(this.handleSuccess.bind(this))
      .catch(this.handleError.bind(this));
  }

  handleReset() {
    this.pristineForm.reset();
    this.dom.$submit.disabled = this.defaultSubmitDisableValue;
  }

  handleSuccess(res) {
    if (!res.Success) {
      this.handleError(res.Message);
      this.setLoading(false);
      return;
    }

    if (this.dom.$error) this.dom.$error.style.display = 'none';

    if (res.RedirectUrl) {
      window.location = res.RedirectUrl;
      return;
    }

    this.setLoading(false);
    this.dom.$form.classList.remove(this.errorClass);
    this.dom.$form.classList.add(this.successClass);

    const event = new CustomEvent('successfullysubmitted', { detail: res });
    this.dom.$form.dispatchEvent(event);
  }

  handleError(msg) {
    this.dom.$form.classList.add(this.errorClass);
    this.dom.$form.classList.remove(this.successClass);

    if (this.dom.$error) {
      this.dom.$error.style.display = 'block';
      this.dom.$error.innerHTML = msg || this.defaultError;
    }

    this.setLoading(false);

    const event = new CustomEvent('submiterror', { detail: msg });
    this.dom.$form.dispatchEvent(event);
  }

  handleSubmitButtonEnability(e) {
    this.handlePhone(e);
    const valid = this.pristineForm.validate(true);
    if (!this.dom.$submit) this.dom.$submit = this.el._$('[type="submit"]');
    this.dom.$submit.disabled = !valid;
    this.dom.$submit.classList.toggle('btn--disabled', !valid);
  }

  handlePhone(e) {
    if (e.target.type === 'tel') {
      e.target.value = e.target.value.replace(/[^0-9-]/g, '');
    }
  }

  handleAnimationStart(e) {
    if (e.animationName === 'onautofillstart') {
      this.setAutocomplete(e.target);
    } else {
      this.cancelAutocomplete(e.target);
    }
  }

  handleInput(e) {
    if (e.inputType === 'insertReplacementText' || !('data' in event)) {
      this.setAutocomplete(e.target);
    } else {
      this.cancelAutocomplete(e.target);
    }
  }

  setAutocomplete(element) {
    if (element.hasAttribute('autocompleted')) return;
    element.setAttribute('autocompleted', '');

    const event = new window.CustomEvent('onautocomplete', {
      bubbles: true, cancelable: true, detail: null
    });

    // no autofill if preventDefault is called by handleAutocomplete
    if (!element.dispatchEvent(event)) {
      element.value = '';
    }
  }

  cancelAutocomplete(element) {
    if (!element.hasAttribute('autocompleted')) return;
    element.removeAttribute('autocompleted');

    // dispatch event
    element.dispatchEvent(new window.CustomEvent('onautocomplete', {
      bubbles: true, cancelable: false, detail: null
    }));
  }

  handleAutocomplete(e) {
    this.handleSubmitButtonEnability(e);
  }
}

export default Module;
